import Icon from '../atomic/Icon'
import LazyLoad from 'react-lazyload'
import React from 'react'

const TabProgettoSpecialeCard = React.memo(({ tab, toggle, accordion = false }) => {
  const thumb = tab.main_image || '/images/demo/articoli_header.png'

  return (
    <div
      className={`progetti-speciali__cards__item ${accordion ? 'trigger' : ''}`}
      onClick={toggle}
    >
      <LazyLoad height={160} once>
        <img src={thumb} alt={tab.titolo} />
      </LazyLoad>
      <a href={'#' + tab.slug}>{tab.titolo}</a>
      {accordion && <Icon id="chevron-down" />}
    </div>
  )
})

export default TabProgettoSpecialeCard
